import { Puzzle } from "lucide-react";

const ITEMS = [
  "Childcare in Halethorpe, MD",
  "Open 7 Days a Week",
  "Ages 2–12",
  "Before & After School Care",
  "Weekend Childcare",
  "Child Care Scholarships Accepted",
  "Homework Support",
  "Snacks & Milk Provided",
];

const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-amber-100/10 bg-deepteal py-4">
    <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-8">
          <span className="font-serif text-lg sm:text-xl italic text-amber-100/90">{item}</span>
          <Puzzle className="h-4 w-4 text-amber-400/70" strokeWidth={1.8} />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
